import { useFormik } from "formik";
import React from "react";
import { useEffect } from "react";
import { setApplicationInfo } from "../../../redux/slice/customer/customerSlice";
import { baseSchema } from "../../../utils/validators/schema";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { useSignature } from "../../../utils/hooks/useSignature";
import { flashMessage } from "../../../utils/flash";

const BusinessInformation = ({ contactInfoRef }) => {
  const {
    value: sign,
    Signature,
    clearSignature,
    saveSignature,
  } = useSignature();

  const onSubmit = (values) => {
    // if (!sign) {
    //   flashMessage("error", "Customer signature required");
    //   return;
    // }
    contactInfoRef.current.click();
  };

  const {
    values,
    errors,
    handleChange,
    handleBlur,
    handleSubmit,
    setFieldValue,
    touched,
  } = useFormik({
    initialValues: {
      business_name: "",
      business_type: "",
      target_category: "",
      number_of_customer: "",
      customer_signature: "",
    },
    validationSchema: baseSchema,
    onSubmit,
  });

  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch(setApplicationInfo({ ...values, customer_signature: sign }));
  }, [values, sign]);

  return (
    <div className='border border-top-0 pb-3 px-3'>
      <form onSubmit={handleSubmit}>
        <div className='row'>
          <div className='mb-0 mt-3 col-md-6'>
            <label
              htmlFor='inputEmail4'
              className='form-label d-flex align-baseline'
            >
              <span>Business Name</span>
              <span className='text-danger'>*</span>
            </label>
            <input
              name='business_name'
              type='text'
              id='business_name'
              value={values.business_name}
              onChange={handleChange}
              onBlur={handleBlur}
              className={`form-control ${
                errors.business_name && touched.business_name
                  ? "is-invalid"
                  : ""
              }`}
              placeholder='Business Name'
            />
            {errors.business_name && touched.business_name && (
              <span className='invalid-feedback'>{errors.business_name}</span>
            )}
          </div>
          <div className='mb-0 mt-3 col-md-6'>
            <label
              htmlFor='inputEmail4'
              className='form-label d-flex align-baseline'
            >
              <span>Business Type</span>
              <span className='text-danger'>*</span>
            </label>
            <input
              name='business_type'
              id='business_type'
              value={values.business_type}
              onChange={handleChange}
              onBlur={handleBlur}
              type='text'
              className={`form-control ${
                errors.business_type && touched.business_type
                  ? "is-invalid"
                  : ""
              }`}
              placeholder='Business type'
            />
            {errors.business_type && touched.business_type && (
              <span className='invalid-feedback'>{errors.business_type}</span>
            )}
          </div>
          <div className='mb-0 mt-3 col-md-6'>
            <label
              htmlFor='inputEmail4'
              className='form-label d-flex align-baseline'
            >
              <span>No. of Customers</span>
              <span className='text-danger'>*</span>
            </label>
            <input
              name='number_of_customer'
              id='number_of_customer'
              value={values.number_of_customer}
              onChange={handleChange}
              onBlur={handleBlur}
              type='number'
              className={`form-control ${
                errors.number_of_customer && touched.number_of_customer
                  ? "is-invalid"
                  : ""
              }`}
              placeholder='Enter number of customers'
            />
            {errors.number_of_customer && touched.number_of_customer && (
              <span className='invalid-feedback'>
                {errors.number_of_customer}
              </span>
            )}
          </div>

          <div className='mb-0 mt-3 col-md-6'>
            <label
              htmlFor='inputEmail4'
              className='form-label d-flex align-baseline'
            >
              <span>Target Category</span>
              <span className='text-danger'>*</span>
            </label>
            <select
              name='target_category'
              id='target_category'
              value={values.target_category}
              onChange={handleChange}
              onBlur={handleBlur}
              className={`form-control ${
                errors.target_category && touched.target_category
                  ? "is-invalid"
                  : ""
              }`}
            >
              <option value=''>-- select an option--</option>
              <option value='Employees'>Employees</option>
              <option value='Customers'>Customers</option>
            </select>
            {errors.target_category && touched.target_category && (
              <span className='invalid-feedback'>{errors.target_category}</span>
            )}
          </div>
          <div className='row my-2'>
            <div className='col-md-6 mt-2'>
              <label htmlFor='inputEmail4' className='form-label d-block'>
                Customer signature
                {/* <span className='text-danger'>*</span> */}
                {sign && (
                  <span className='bg-dar ms-1 text-success'>
                    <i className={`mdi mdi-check fs-5 h3 mt-0`}></i>{" "}
                  </span>
                )}
              </label>
              <div className='d-flex gap-3'>{Signature}</div>
              <div className='d-flex gap-2 mt-2'>
                <button
                  type='button'
                  className='btn btn-sm btn-secondary'
                  onClick={() => clearSignature()}
                >
                  Clear signature
                </button>
                <button
                  type='button'
                  className='btn btn-sm btn-info'
                  onClick={() => {
                    saveSignature();
                  }}
                >
                  Sign
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className='d-flex justify-content-end mb-3 mt-3'>
          <button type='submit' className='btn btn-primary'>
            Proceed
          </button>
        </div>
      </form>
    </div>
  );
};

export default BusinessInformation;
